<template>
  <div class="report-radio-buttons-container">
    <div class="report-radio-buttons-title">
      {{
        title || adminText(&quot;shellAll.select_a_period_you_would_like_to_generate_a_statistics_for&quot;, &quot;Select a period you would like to generate a statistics for:&quot;)
      }}
    </div>
    <div class="report-radio-buttons">
      <custom-radio-button
        :label="adminText(&quot;shellAll.6_months&quot;, &quot;6 months&quot;)"
        :value="checkedReportOption === 1"
        @click="$emit('changeCheckedOption', 1)"
      />
      <custom-radio-button
        :label="adminText(&quot;shellAll.12_months&quot;, &quot;12 months&quot;)"
        class="two-weeks-button"
        :value="checkedReportOption === 2"
        @click="$emit('changeCheckedOption', 2)"
      />
      <date-picker
        :lang="isAdminLocalization ? $adminLocale() : undefined"
        :value="dateRange"
        :clearable="false"
        type="month"
        range
        :placeholder="adminText(&quot;shellAll.select_date_range&quot;, &quot;Select date range&quot;)"
        :disabled-date="maxDateRange && disabledDate"
        @change="$emit('changeDateRange', $event)"
      >
        <template v-slot:input="{}">
          <custom-radio-button
            :label="
              checkedReportOption === 3
                ? `${formatDate(dateRange[0], 'YY\'/MM')} - ${formatDate(dateRange[1], 'YY\'/MM')}`
                : adminText(&quot;shellAll.custom_choice&quot;, &quot;Custom choice&quot;)
            "
            :value="checkedReportOption === 3"
            @click="$emit('changeCheckedOption', 3)"
          />
        </template>
        <i slot="icon-calendar" />
      </date-picker>
    </div>
  </div>
</template>

<script>
import AdminContext from '@/admin-i18n/context'
import customRadioButton from '@/components/events/custom-radio-button.vue'
import { formatDate } from '@/utils'
import moment from 'moment/moment'
import DatePicker from 'vue2-datepicker'
import hrDateFormat from 'date-format-parse/lib/locale/hr'

DatePicker.locale('hr', { formatLocale: hrDateFormat, yearFormat: 'YYYY', monthFormat: 'MMM', monthBeforeYear: true }, true)

export default {
  mixins: [AdminContext],
  name: 'graph-month-filters',
  components: { customRadioButton, DatePicker },
  props: {
    title: String,
    checkedReportOption: Number,
    dateFilterOptions: {
      type: Array,
      default: () => [],
    },
    dateRange: Array,
    maxDateRange: Number,
  },
  methods: {
    formatDate,
    disabledDate(date, currentValue) {
      if (currentValue.length !== 1) return false

      return (
        date < currentValue[0] || date > moment(currentValue[0]).add(this.maxDateRange - 1, 'month')
      )
    }},
}
</script>

<style>
.report-radio-buttons-title {
  font-family: 'Source Sans Pro', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16.8px;
  color: #979797;
  margin-top: 30px;
  margin-left: 20px;
  margin-bottom: 12px;
}

.report-radio-buttons {
  display: flex;
  margin: 0 20px;
}

.radio-button-container {
  display: flex;
  height: fit-content;
  position: relative;
  padding: 0.5rem 1rem 0.5rem 2.875rem;
  border: 2px solid #666666;
  border-radius: 1.5rem;
  font-family: 'Raleway', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 1rem;
  line-height: 120%;
  letter-spacing: -0.015em;
  font-feature-settings: 'pnum' on, 'onum' on;
  color: #666666;
  user-select: none;
}

.radio-button-container:not(:first-child) {
  margin-left: 1rem;
}

.radio-button-container.checked {
  background-color: white !important;
  color: #0277bd !important;
  border-color: #0277bd;
}

.radio-button-container.checked:hover {
  background-color: #0277bd;
}

.radio-button-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.radio-button-container:hover input ~ .checkmark,
.radio-button-container:hover {
  background-color: rgb(231, 231, 231);
}

.radio-button-container input:checked ~ .checkmark {
  background-color: #0277bd;
  border: 2px solid white;
  height: 1.5rem;
  width: 1.5rem;
  left: 0.8rem;
}

.radio-button-container input:checked ~ .checkmark:after {
  display: block;
  box-sizing: border-box;
}

.radio-button-container .checkmark:after {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 16px;
  height: 16px;
  border: 3px solid white;
  border-radius: 100px;
}

div.mx-datepicker {
  width: fit-content;
}

@media only screen and (max-width: 930px) {
  .two-weeks-button,
  .three-weeks-button {
    display: none !important;
  }
}

.report-radio-buttons-container {
  margin-bottom: 44px;
}
</style>
